<ng-container *ngIf="!loading">
  
    <!-- BANNER E TITOLO -->           
    <div class="banner" [ngStyle]="{'background-image': notizia?.copertina ? 'url('  + apiUrl + 'immagine/' + notizia?.copertina + '), url(../../../../assets/images/7L_tiling_bg_opaque.png)': 'url(../../../../assets/images/7L_tiling_bg_opaque.png)' }"  *ngIf="notizia?.copertina" [@fadeInOut]></div>
    <!-- BANNER E TITOLO -->    

</ng-container>  

<div class="xl:px-container lg:px-16 px-8">    
  
    <!-- LOADER -->
    <app-video-loading class="flex items-center justify-center my-8" *ngIf="loading"></app-video-loading>  
    <!-- LOADER -->
    
    <div class="flex flex-col gap-4 mt-8">
        <h3 class="font-bold text-3xl text-white lg:text-4xl testo">{{notizia?.titolo}}</h3>
        <span class="prose-invert max-w-none news-desc prose" [innerHTML]="notizia?.descrizione"></span>
        
        <div class="flex flex-wrap gap-4 mt-4">
            <div class="image" *ngFor="let immagine of immagini">                            
                <img [src]="apiUrl + 'immagine/' + immagine.immagine" alt="Immagine News" class="cursor-pointer object-contain h-64 hover:scale-[1.03] transition-all duration-300" (click)="openImg(popUpImage)" >
                <ng-template #popUpImage>
                    <div class="text-right">
                        <button (click)="popupImage?.close()" class="me-[5%] lg:me-0 text-4xl btn-primary btn-sm focus-visible:outline-none">&times;</button>
                        <img [src]="apiUrl + 'immagine/' + immagine.immagine" alt="" class="mx-auto max-w-[90%] lg:max-w-[100%] max-h-[90vh]">
                    </div>
                </ng-template>
            </div>
        </div>    
    </div>
  
</div>